import React from "@platform/react";
import { Component } from "@platform/react-storybook/Component";

import { useNavigate } from "@app/common/router/utils";
import { useItemsNav } from "@app/common/hooks/items-nav";

import { ContainerWww } from "@front/components/Container/Www/index";
import { PopUp } from "@front/components/Element/PopUp";
import { VectorAsset } from "@front/components/Element/Asset/Vector";

import { useDispatch, useSelector } from "@front/store/index";
import { ActionSliceSession, SelectorSliceSession } from "@front/store/slices/session";

import { usePathWww } from "@app/common/router/routes/www";
import {
    DEF_CONTAINER_WWW_ROOT,
    NAME_CONTAINER_WWW_ROOT,
    SECTION_CONTAINER_WWW_ROOT,
    TYPE_CONTAINER_WWW_ROOT,
} from "./types";
import type { PropContainerWwwRoot } from "./types";

import Rules from "./_rules.module.scss";

export function ContainerWwwRoot(props: PropContainerWwwRoot) {
    const { children, isBackgroundEnabled, onFooterClick, ...rest } = props;

    const navigate = useNavigate();
    const { footer, menu } = useItemsNav();
    const pathHome = usePathWww("WWW_HOME");

    const dispatch = useDispatch();
    const isFirstTimeOpenApp = useSelector(SelectorSliceSession.isFirstTimeOpenApp);

    return (
        <ContainerWww className={isBackgroundEnabled ? Rules.background : ""}>
            {({ SectionHeader, SectionMenu, SectionFooter, ...Section }) => {
                const Components = { ...Section, ...SECTION_CONTAINER_WWW_ROOT };
                const _children = typeof children === "function" ? children(Components) : children;
                return (
                    <React.Fragment>
                        <SectionHeader hasTrigger items={menu} onClickLogo={handleClickLogo} />
                        <SectionMenu items={menu} />
                        {isBackgroundEnabled && <VectorAsset stroke="chile" uuid="lines-wave-2" />}
                        <Component
                            {...rest}
                            name={NAME_CONTAINER_WWW_ROOT}
                            tag="article"
                            type={TYPE_CONTAINER_WWW_ROOT}>
                            {_children}
                        </Component>
                        {onFooterClick && (
                            <SectionFooter items={footer} onClickStarted={onFooterClick} />
                        )}
                        {isFirstTimeOpenApp && (
                            <PopUp bitmap="pup-up-banner" onClick={handleClosePopup} />
                        )}
                    </React.Fragment>
                );
            }}
        </ContainerWww>
    );

    function handleClickLogo() {
        navigate(pathHome);
    }

    function handleClosePopup() {
        dispatch(ActionSliceSession.set({ isFirstTimeOpenApp: false }));
    }
}
ContainerWwwRoot.defaultProps = DEF_CONTAINER_WWW_ROOT;
